module.exports = __webpack_public_path__ + "img/pending_zone.dba09efd.svg";